import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { User } from '../../app/models/user.model';
import { MystopiaUsers } from '../../providers/mystopia-users';

/*
  Generated class for the UserDetails page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-user-details',
  templateUrl: 'user-details.html'
})
export class UserDetailsPage {
  user: User;
  userId: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private mystopiaUsers: MystopiaUsers) {
    this.userId = navParams.get('userId');
    mystopiaUsers.getUserDetails(this.userId)
      .subscribe(
        (user) => {
          this.user = user;
          console.log(this.user);
        }
      );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UserDetailsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-details/user-details.ts